(function() {
  if (window.__amzProductZoomReady) return;
  window.__amzProductZoomReady = true;

  var modal = null;
  var els = {};
  var state = {
    items: [],
    index: 0,
    scale: 1,
    x: 0,
    y: 0,
    scope: null,
    lastFocus: null,
    pointerStart: null,
    modalPointer: null,
    pinch: null,
    loadToken: 0,
    skipNextModalClick: false,
    ignoreNextImageClick: false,
    isPanning: false
  };

  var imageCache = {};
  var pendingLoads = {};

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function safeFocus(el) {
    if (!el || !el.focus) return;
    try {
      el.focus({ preventScroll: true });
    } catch (error) {
      el.focus();
    }
  }

  function closest(el, selector) {
    if (!el || el === document) return null;
    return el.closest ? el.closest(selector) : null;
  }

  function toNumber(value, fallback) {
    var parsed = parseFloat(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function isZoomImage(img) {
    return img && img.matches && img.matches('img.photoswipe__image[data-photoswipe-src]');
  }

  function isHidden(el) {
    if (!el) return true;
    var node = el;
    while (node && node !== document.body) {
      if (node.nodeType === 1) {
        var style = window.getComputedStyle(node);
        if (style.display === 'none' || style.visibility === 'hidden') return true;
      }
      node = node.parentElement;
    }
    return false;
  }

  function getImageFromTrigger(trigger) {
    if (!trigger) return null;
    if (trigger.matches && trigger.matches('img.photoswipe__image')) return trigger;
    var holder = closest(trigger, '.product-main-slide, .amz-desktop-media__item, .product-image-main, .image-wrap, [data-product-image-main]');
    if (holder) {
      var img = holder.querySelector('img.photoswipe__image[data-photoswipe-src]');
      if (img) return img;
    }
    var product = closest(trigger, '.product-section');
    if (product) return product.querySelector('img.photoswipe__image[data-photoswipe-src]');
    return null;
  }

  function getScope(img) {
    return closest(img, '.amz-desktop-media') || closest(img, '[data-product-images]') || closest(img, '.product__photos') || closest(img, '.product-section') || document;
  }


  function getSrcsetFallback(img) {
    var srcset = img && img.getAttribute ? img.getAttribute('srcset') : '';
    if (!srcset) return '';
    var first = srcset.split(',')[0];
    return first ? first.trim().split(/\s+/)[0] : '';
  }

  function getItem(img) {
    return {
      src: img.getAttribute('data-photoswipe-src') || img.currentSrc || img.src,
      msrc: img.currentSrc || img.src || getSrcsetFallback(img) || img.getAttribute('data-photoswipe-src'),
      width: toNumber(img.getAttribute('data-photoswipe-width'), img.naturalWidth || 1800),
      height: toNumber(img.getAttribute('data-photoswipe-height'), img.naturalHeight || 1800),
      alt: img.getAttribute('alt') || '',
      el: img
    };
  }

  function isReady(src, item) {
    if (!src) return false;
    var cached = imageCache[src];
    if (cached && cached.complete && cached.naturalWidth) return true;
    if (item && item.el && item.el.complete && item.el.naturalWidth) {
      if (item.el.currentSrc === src || item.el.src === src) return true;
    }
    return false;
  }

  function preloadImage(src, callback) {
    if (!src) {
      if (callback) callback(false);
      return null;
    }
    var cached = imageCache[src];
    if (cached && cached.complete && cached.naturalWidth) {
      if (callback) callback(true);
      return cached;
    }
    if (cached && pendingLoads[src]) {
      if (callback) pendingLoads[src].push(callback);
      return cached;
    }
    var image = cached || new Image();
    image.decoding = 'async';
    imageCache[src] = image;
    pendingLoads[src] = callback ? [callback] : [];
    image.onload = function() {
      var callbacks = pendingLoads[src] || [];
      delete pendingLoads[src];
      callbacks.forEach(function(done) { done(true); });
    };
    image.onerror = function() {
      var callbacks = pendingLoads[src] || [];
      delete pendingLoads[src];
      callbacks.forEach(function(done) { done(false); });
    };
    if (image.src !== src) image.src = src;
    return image;
  }

  function preloadItem(item) {
    if (!item) return;
    preloadImage(item.msrc || item.src);
    if (item.src && item.src !== item.msrc) preloadImage(item.src);
  }

  function preloadItems(items, startIndex) {
    if (!items || !items.length) return;
    var total = items.length;
    var order = [startIndex, startIndex + 1, startIndex - 1];
    for (var i = 0; i < total; i++) order.push(i);
    var seen = [];
    order.forEach(function(rawIndex) {
      var index = ((rawIndex % total) + total) % total;
      if (seen.indexOf(index) !== -1) return;
      seen.push(index);
      preloadItem(items[index]);
    });
  }

  function schedulePagePreload() {
    var run = function() {
      var images = Array.prototype.slice.call(document.querySelectorAll('img.photoswipe__image[data-photoswipe-src]'));
      var seen = [];
      images.forEach(function(img) {
        if (!isZoomImage(img) || isHidden(img)) return;
        var item = getItem(img);
        if (!item.src || seen.indexOf(item.src) !== -1) return;
        seen.push(item.src);
        preloadItem(item);
      });
    };
    var start = function() {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(run, { timeout: 1600 });
      } else {
        setTimeout(run, 450);
      }
    };
    if (document.readyState === 'complete') {
      start();
    } else {
      window.addEventListener('load', start, { once: true });
    }
  }

  function collectImages(scope) {
    var images = Array.prototype.slice.call(scope.querySelectorAll('img.photoswipe__image[data-photoswipe-src]'));
    var seen = [];
    var items = [];
    images.forEach(function(img) {
      if (!isZoomImage(img)) return;
      var src = img.getAttribute('data-photoswipe-src') || img.currentSrc || img.src;
      if (!src || seen.indexOf(src) !== -1) return;
      seen.push(src);
      items.push(getItem(img));
    });
    return items;
  }

  function ensureModal() {
    if (modal) return;
    modal = document.createElement('div');
    modal.className = 'amz-product-zoom';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-hidden', 'true');
    modal.innerHTML = [
      '<div class="amz-product-zoom__backdrop" data-amz-zoom-close></div>',
      '<div class="amz-product-zoom__shell">',
        '<div class="amz-product-zoom__topbar">',
          '<div class="amz-product-zoom__counter" data-amz-zoom-counter></div>',
          '<div class="amz-product-zoom__actions">',
            '<button type="button" class="amz-product-zoom__button" data-amz-zoom-out aria-label="Zoom out">−</button>',
            '<button type="button" class="amz-product-zoom__button" data-amz-zoom-reset aria-label="Reset zoom">100%</button>',
            '<button type="button" class="amz-product-zoom__button" data-amz-zoom-in aria-label="Zoom in">+</button>',
            '<button type="button" class="amz-product-zoom__button amz-product-zoom__button--close" data-amz-zoom-close aria-label="Close image zoom">×</button>',
          '</div>',
        '</div>',
        '<button type="button" class="amz-product-zoom__nav amz-product-zoom__nav--prev" data-amz-zoom-prev aria-label="Previous image">‹</button>',
        '<div class="amz-product-zoom__viewport" data-amz-zoom-viewport>',
          '<img class="amz-product-zoom__image" data-amz-zoom-image alt="">',
        '</div>',
        '<button type="button" class="amz-product-zoom__nav amz-product-zoom__nav--next" data-amz-zoom-next aria-label="Next image">›</button>',
        '<div class="amz-product-zoom__thumbs" data-amz-zoom-thumbs></div>',
      '</div>'
    ].join('');
    document.body.appendChild(modal);
    els.viewport = modal.querySelector('[data-amz-zoom-viewport]');
    els.image = modal.querySelector('[data-amz-zoom-image]');
    els.image.decoding = 'async';
    if ('fetchPriority' in els.image) els.image.fetchPriority = 'high';
    els.counter = modal.querySelector('[data-amz-zoom-counter]');
    els.thumbs = modal.querySelector('[data-amz-zoom-thumbs]');
    els.prev = modal.querySelector('[data-amz-zoom-prev]');
    els.next = modal.querySelector('[data-amz-zoom-next]');
    els.zoomIn = modal.querySelector('[data-amz-zoom-in]');
    els.zoomOut = modal.querySelector('[data-amz-zoom-out]');
    els.reset = modal.querySelector('[data-amz-zoom-reset]');
    bindModal();
  }

  function isDesktopPointer() {
    return !window.matchMedia || window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  function eventInsideImage(event) {
    if (!els.image || !event) return false;
    var rect = els.image.getBoundingClientRect();
    return event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
  }

  function stepZoomIn(event) {
    if (event && typeof event.clientX === 'number') {
      setScaleAt(state.scale + 0.5, event.clientX, event.clientY);
      return;
    }
    setScale(state.scale + 0.5);
  }

  function stepZoomOut(event) {
    if (event && typeof event.clientX === 'number') {
      setScaleAt(state.scale - 0.5, event.clientX, event.clientY);
      return;
    }
    setScale(state.scale - 0.5);
  }

  function bindModal() {
    modal.querySelectorAll('[data-amz-zoom-close]').forEach(function(button) {
      button.addEventListener('click', closeModal);
    });
    els.prev.addEventListener('click', function() { go(state.index - 1); });
    els.next.addEventListener('click', function() { go(state.index + 1); });
    els.zoomIn.addEventListener('click', function() { setScale(state.scale + 0.5); });
    els.zoomOut.addEventListener('click', function() { setScale(state.scale - 0.5); });
    els.reset.addEventListener('click', function() { resetZoom(); });
    els.image.addEventListener('dblclick', function(event) {
      event.preventDefault();
      event.stopPropagation();
    });
    els.viewport.addEventListener('click', onViewportClick);
    els.viewport.addEventListener('contextmenu', onViewportContextMenu);
    els.viewport.addEventListener('wheel', onViewportWheel, { passive: false });
    els.viewport.addEventListener('pointerdown', onModalPointerDown);
    els.viewport.addEventListener('pointermove', onModalPointerMove);
    els.viewport.addEventListener('pointerup', onModalPointerUp);
    els.viewport.addEventListener('pointercancel', onModalPointerUp);
    els.viewport.addEventListener('touchstart', onTouchStart, { passive: false });
    els.viewport.addEventListener('touchmove', onTouchMove, { passive: false });
    els.viewport.addEventListener('touchend', onTouchEnd, { passive: false });
    modal.addEventListener('click', onModalClickOutside);
  }

  function openFrom(img) {
    ensureModal();
    if (!isZoomImage(img) || isHidden(img)) return;
    var scope = getScope(img);
    var items = collectImages(scope);
    var clickedSrc = img.getAttribute('data-photoswipe-src') || img.currentSrc || img.src;
    var index = items.findIndex(function(item) { return item.src === clickedSrc; });
    if (index < 0) {
      items.unshift(getItem(img));
      index = 0;
    }
    if (!items.length) return;
    state.items = items;
    state.scope = scope;
    state.index = index;
    state.lastFocus = document.activeElement;
    preloadItems(items, index);
    renderThumbs();
    modal.classList.add('is-active', 'is-loading');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('amz-product-zoom-open');
    go(index, true);
    setTimeout(function() {
      var close = modal.querySelector('[data-amz-zoom-close].amz-product-zoom__button--close');
      if (close) safeFocus(close);
    }, 20);
  }

  function closeModal() {
    if (!modal || !modal.classList.contains('is-active')) return;
    modal.classList.remove('is-active', 'is-zoomed', 'is-loading');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('amz-product-zoom-open');
    resetZoom();
    if (state.lastFocus && state.lastFocus.focus) {
      setTimeout(function() { safeFocus(state.lastFocus); }, 30);
    }
  }

  function renderThumbs() {
    els.thumbs.innerHTML = '';
    if (state.items.length <= 1) {
      els.thumbs.hidden = true;
      return;
    }
    els.thumbs.hidden = false;
    state.items.forEach(function(item, index) {
      var button = document.createElement('button');
      var thumb = document.createElement('img');
      button.type = 'button';
      button.className = 'amz-product-zoom__thumb';
      button.setAttribute('aria-label', 'Open image ' + (index + 1));
      thumb.src = item.msrc || item.src;
      thumb.alt = item.alt;
      thumb.loading = 'eager';
      thumb.decoding = 'async';
      button.appendChild(thumb);
      button.addEventListener('click', function() { go(index); });
      els.thumbs.appendChild(button);
    });
  }

  function go(index, instant) {
    if (!state.items.length) return;
    if (index < 0) index = state.items.length - 1;
    if (index >= state.items.length) index = 0;
    state.index = index;
    var item = state.items[index];
    resetZoom();
    showItem(item);
    preloadItems(state.items, index);
    els.counter.textContent = state.items.length > 1 ? (index + 1) + ' / ' + state.items.length : '';
    els.prev.hidden = state.items.length <= 1;
    els.next.hidden = state.items.length <= 1;
    Array.prototype.slice.call(els.thumbs.children).forEach(function(button, i) {
      var active = i === index;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-current', active ? 'true' : 'false');
      if (active && !instant) button.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    });
    if (state.scope && typeof CustomEvent === 'function') {
      state.scope.dispatchEvent(new CustomEvent('photoswipe:afterChange', { detail: { index: index } }));
    }
  }


  function showItem(item) {
    state.loadToken += 1;
    var token = state.loadToken;
    var quickSrc = item.msrc || item.src;
    var fullSrc = item.src || quickSrc;

    function setVisibleImage(src, loading) {
      if (!src || token !== state.loadToken) return;
      els.image.onload = null;
      els.image.onerror = null;
      if (els.image.getAttribute('src') !== src) els.image.src = src;
      els.image.alt = item.alt || '';
      if (loading && !isReady(src, item) && !els.image.complete) {
        modal.classList.add('is-loading');
        els.image.onload = function() {
          if (token === state.loadToken) modal.classList.remove('is-loading');
        };
        els.image.onerror = function() {
          if (token === state.loadToken) modal.classList.remove('is-loading');
        };
      } else {
        modal.classList.remove('is-loading');
      }
    }

    if (fullSrc && isReady(fullSrc, item)) {
      setVisibleImage(fullSrc, false);
      return;
    }

    if (quickSrc) {
      setVisibleImage(quickSrc, !isReady(quickSrc, item));
    } else if (fullSrc) {
      setVisibleImage(fullSrc, true);
    }

    if (fullSrc) {
      preloadImage(fullSrc, function(loaded) {
        if (token !== state.loadToken) return;
        if (loaded) {
          setVisibleImage(fullSrc, false);
        } else {
          modal.classList.remove('is-loading');
        }
      });
    }
  }

  function resetZoom() {
    state.scale = 1;
    state.x = 0;
    state.y = 0;
    applyTransform();
  }

  function setScale(value) {
    var next = Math.max(1, Math.min(4, value));
    if (next === 1) {
      state.x = 0;
      state.y = 0;
    }
    state.scale = next;
    applyTransform();
  }

  function setScaleAt(value, clientX, clientY) {
    var previous = state.scale;
    var next = Math.max(1, Math.min(4, value));
    if (next === previous) return;
    if (next === 1) {
      state.x = 0;
      state.y = 0;
      state.scale = 1;
      applyTransform();
      return;
    }
    var rect = els.image.getBoundingClientRect();
    var centerX = rect.left + rect.width / 2;
    var centerY = rect.top + rect.height / 2;
    var ratio = next / previous;
    state.x += (clientX - centerX) * (1 - ratio);
    state.y += (clientY - centerY) * (1 - ratio);
    state.scale = next;
    applyTransform();
  }

  function getPanBounds() {
    if (!els.viewport || !els.image || state.scale <= 1) return { x: 0, y: 0 };
    var viewportRect = els.viewport.getBoundingClientRect();
    var imageWidth = els.image.offsetWidth || els.image.naturalWidth || 0;
    var imageHeight = els.image.offsetHeight || els.image.naturalHeight || 0;
    var scaledWidth = imageWidth * state.scale;
    var scaledHeight = imageHeight * state.scale;
    return {
      x: Math.max(0, (scaledWidth - viewportRect.width) / 2),
      y: Math.max(0, (scaledHeight - viewportRect.height) / 2)
    };
  }

  function clampPan() {
    if (state.scale <= 1) {
      state.x = 0;
      state.y = 0;
      return;
    }
    var bounds = getPanBounds();
    state.x = Math.max(-bounds.x, Math.min(bounds.x, state.x));
    state.y = Math.max(-bounds.y, Math.min(bounds.y, state.y));
  }

  function applyTransform() {
    clampPan();
    els.image.style.transform = 'translate3d(' + state.x + 'px,' + state.y + 'px,0) scale(' + state.scale + ')';
    modal.classList.toggle('is-zoomed', state.scale > 1);
    modal.classList.toggle('is-panning', state.isPanning);
    els.reset.textContent = Math.round(state.scale * 100) + '%';
  }

  function onModalPointerDown(event) {
    if (!modal.classList.contains('is-active') || event.button && event.button !== 0) return;
    var inside = eventInsideImage(event);
    var canPan = state.scale > 1 && inside;
    state.modalPointer = {
      id: event.pointerId,
      x: event.clientX,
      y: event.clientY,
      startX: state.x,
      startY: state.y,
      swiped: false,
      panning: canPan
    };
    if (canPan) {
      event.preventDefault();
      event.stopPropagation();
      state.isPanning = true;
      applyTransform();
    }
    if (els.viewport.setPointerCapture) {
      try { els.viewport.setPointerCapture(event.pointerId); } catch (error) {}
    }
  }

  function onModalPointerMove(event) {
    if (!state.modalPointer || state.modalPointer.id !== event.pointerId) return;
    var dx = event.clientX - state.modalPointer.x;
    var dy = event.clientY - state.modalPointer.y;
    if (state.modalPointer.panning) {
      event.preventDefault();
      event.stopPropagation();
      state.x = state.modalPointer.startX + dx;
      state.y = state.modalPointer.startY + dy;
      applyTransform();
      return;
    }
    if (Math.abs(dx) > 10 || Math.abs(dy) > 10) {
      state.modalPointer.swiped = true;
    }
  }

  function onModalPointerUp(event) {
    if (!state.modalPointer || state.modalPointer.id !== event.pointerId) return;
    var dx = event.clientX - state.modalPointer.x;
    var dy = event.clientY - state.modalPointer.y;
    var moved = Math.abs(dx) > 6 || Math.abs(dy) > 6;
    var wasPanning = state.modalPointer.panning;
    if (moved || wasPanning) {
      state.ignoreNextImageClick = true;
      setTimeout(function() { state.ignoreNextImageClick = false; }, 220);
    }
    if (!wasPanning && state.scale === 1 && Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.3) {
      state.skipNextModalClick = true;
      go(dx < 0 ? state.index + 1 : state.index - 1);
      setTimeout(function() { state.skipNextModalClick = false; }, 140);
    }
    state.isPanning = false;
    state.modalPointer = null;
    applyTransform();
  }

  function onViewportClick(event) {
    if (!modal || !modal.classList.contains('is-active')) return;
    if (!eventInsideImage(event)) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    if (state.ignoreNextImageClick) return;
    if (isDesktopPointer()) stepZoomIn(event);
  }

  function onViewportContextMenu(event) {
    if (!modal || !modal.classList.contains('is-active')) return;
    if (!eventInsideImage(event)) return;
    if (!isDesktopPointer()) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    stepZoomOut(event);
  }

  function onViewportWheel(event) {
    if (!modal || !modal.classList.contains('is-active')) return;
    if (!isDesktopPointer()) return;
    if (!eventInsideImage(event)) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    var direction = event.deltaY < 0 ? 1 : -1;
    var step = event.ctrlKey ? 0.18 : 0.28;
    setScaleAt(state.scale + direction * step, event.clientX, event.clientY);
  }

  function onModalClickOutside(event) {
    if (!modal || !modal.classList.contains('is-active')) return;
    if (state.skipNextModalClick) return;
    var target = event.target;
    if (eventInsideImage(event)) return;
    if (closest(target, '.amz-product-zoom__image')) return;
    if (closest(target, '.amz-product-zoom__button')) return;
    if (closest(target, '.amz-product-zoom__nav')) return;
    if (closest(target, '.amz-product-zoom__thumb')) return;
    if (closest(target, '.amz-product-zoom__counter')) return;
    closeModal();
  }

  function touchDistance(touches) {
    var x = touches[0].clientX - touches[1].clientX;
    var y = touches[0].clientY - touches[1].clientY;
    return Math.sqrt(x * x + y * y);
  }

  function onTouchStart(event) {
    if (event.touches.length === 2) {
      state.pinch = {
        distance: touchDistance(event.touches),
        scale: state.scale
      };
    }
  }

  function onTouchMove(event) {
    if (event.touches.length === 2 && state.pinch) {
      event.preventDefault();
      setScale(state.pinch.scale * (touchDistance(event.touches) / state.pinch.distance));
    }
  }

  function onTouchEnd(event) {
    if (event.touches.length < 2) state.pinch = null;
  }

  function onDocumentPointerDown(event) {
    state.pointerStart = {
      x: event.clientX,
      y: event.clientY,
      moved: false
    };
  }

  function onDocumentPointerMove(event) {
    if (!state.pointerStart) return;
    if (Math.abs(event.clientX - state.pointerStart.x) > 10 || Math.abs(event.clientY - state.pointerStart.y) > 10) {
      state.pointerStart.moved = true;
    }
  }

  function onGalleryPointerUp(event) {
    // MAIN desktop fix:
    // ApxSlider places the pointer target on .amz-fc-view instead of the
    // actual product image. Bridge a normal click on the gallery viewport
    // back to the currently selected zoom image.
    if (!window.matchMedia || !window.matchMedia('(min-width: 769px)').matches) return;
    if (modal && modal.classList.contains('is-active')) return;
    if (typeof event.button === 'number' && event.button !== 0) return;

    var view = closest(event.target, '.amz-fc-view');
    if (!view) return;

    if (state.pointerStart && state.pointerStart.moved) return;

    var img = view.querySelector(
      '.product-main-slide.is-selected img.photoswipe__image[data-photoswipe-src]'
    );

    if (!img || isHidden(img)) return;

    window.setTimeout(function() {
      img.click();
    }, 0);
  }


  function onDocumentClick(event) {
    var trigger = closest(event.target, '.js-photoswipe__zoom, img.photoswipe__image');
    if (!trigger) return;
    var isButton = trigger.matches('.js-photoswipe__zoom');
    if (!isButton && state.pointerStart && state.pointerStart.moved) return;
    var img = getImageFromTrigger(trigger);
    if (!isZoomImage(img) || isHidden(img)) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    openFrom(img);
  }

  function onKeydown(event) {
    if (!modal || !modal.classList.contains('is-active')) return;
    if (event.key === 'Escape') closeModal();
    if (event.key === 'ArrowLeft') go(state.index - 1);
    if (event.key === 'ArrowRight') go(state.index + 1);
    if (event.key === '+' || event.key === '=') setScale(state.scale + 0.5);
    if (event.key === '-' || event.key === '_') setScale(state.scale - 0.5);
  }

  ready(function() {
    ensureModal();
    document.addEventListener('pointerdown', onDocumentPointerDown, true);
    document.addEventListener('pointermove', onDocumentPointerMove, true);
    document.addEventListener('pointerup', onGalleryPointerUp, true);
    document.addEventListener('click', onDocumentClick, true);
    document.addEventListener('keydown', onKeydown);
    /* ohmique: zoom-preload uit */
  });
})();
